/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowSpaDayTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowSpaDay,

  planType: PlanType.Quickstart,
  suggestedTitles: ["Relax and Unwind!", "Spa Day Bliss!", "Treat Yourself!"],
  title: "Spa Day",
  description: "Organize a relaxing spa day.",
  longDescription:
    "Treat yourselves to a day of relaxation and pampering! Choose a date, decide on spa treatments, and plan refreshments!",
  emoji: "💆",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Spa Day",
          emoji: "💆",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the spa day?",
          emoji: "📅",
          completeAction: {
            question: "Decide on spa treatments?",
            description: "What treatments should we enjoy during our spa day?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What treatments should we choose?",
                emoji: "🧖",
                completeAction: {
                  question: "Decide on refreshments?",
                  description:
                    "What refreshments should we have during the spa day?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What refreshments should we bring?",
                      emoji: "🍵",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Relaxation Awaits!",
    outroDescription: "Your spa day plans are set! Enjoy the pampering!",
  },
};
